export default "__VITE_ASSET__C1sIjD2z__"